import {
  Grid,
  LinearProgress,
  Typography,
  Button,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const BackpackMatches = ({ onMatchClick, onJobClick }) => {
  const [activeMatch, setActiveMatch] = useState("previous");

  const {
    occupationBlacklist,
    skills_backpack_occupations,
    styles_occupations,
    interest_occupations,
  } = useSelector((state) => ({
    occupationBlacklist: state.candidates.selectedCandidateData.occupationBlacklist,
    skills_backpack_occupations: state.candidates.skills_backpack_occupations,
    styles_occupations: state.candidates.styles_occupations,
    interest_occupations: state.candidates.interest_occupations,
  }));

  const matchListMap = {
    previous: skills_backpack_occupations,
    interests: interest_occupations,
    styles: styles_occupations,
  };

  if (!skills_backpack_occupations || !matchListMap[activeMatch]) {
    return null;
  }

  const getScore = (item) => {
    if (activeMatch === "previous") return item.score_bp;
    if (activeMatch === "styles") return item.score_styles;
    return item.score_interest;
  };

  return (
    <Grid container>
      <Grid item size={{xs:5}}>
        <div>
          <Button
            variant="contained"
            sx={{
              fontSize: 12,
              cursor: "pointer",
              ...(activeMatch !== "previous" && { backgroundColor: "#9f9f9f", opacity: 0.8 }),
            }}
            onClick={() => setActiveMatch("previous")}
          >
            Best Skills Match:
          </Button>
        </div>
        <div>
          <Button
            variant="contained"
            sx={{
              fontSize: 12,
              cursor: "pointer",
              mt: 1.875,
              ...(activeMatch !== "styles" && { backgroundColor: "#9f9f9f", opacity: 0.8 }),
            }}
            onClick={() => setActiveMatch("styles")}
          >
            Best style matches:
          </Button>
        </div>
        <div>
          <Button
            variant="contained"
            sx={{
              fontSize: 12,
              cursor: "pointer",
              mt: 1.875,
              ...(activeMatch !== "interests" && { backgroundColor: "#9f9f9f", opacity: 0.8 }),
            }}
            onClick={() => setActiveMatch("interests")}
          >
            Best interest matches:
          </Button>
        </div>
      </Grid>
      <Grid
        item
        size="grow"
        style={{ height: "11em", overflow: "hidden", overflowY: "auto" }}
      >
        <Grid container direction="column" spacing={1}>
          {matchListMap[activeMatch].map((item) => {
            const score = getScore(item);
            return (
              <Grid item key={item.occupation}>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="baseline"
                >
                  <Grid item>
                    <Typography
                      variant="subtitle2"
                      component="p"
                      style={{ maxWidth: "30em", cursor: "pointer" }}
                      onClick={() => {
                        onMatchClick();
                        onJobClick(item);
                      }}
                    >
                      <ArrowRightIcon style={{position: "relative", float: "left"}} /> {item.occupation}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Grid
                      container
                      direction="row"
                      justify="flex-end"
                      alignItems="baseline"
                    >
                      {occupationBlacklist.includes(item.occupation) && (
                      <Grid item sx={{
                        px: 1.25,
                        mb: 0.625,
                        mr: 2.5,
                        backgroundColor:"#ff6505",
                        borderRadius:"5px"
                      }}>
                        <Typography variant="subtitle2" component="p">Candidate not interested</Typography>
                      </Grid>
                      )}
                      <Grid item>
                        <Typography
                          variant="subtitle2"
                          color="primary"
                          style={{ textAlign: "right", marginTop: -19 }}
                        >
                          {score}%
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <LinearProgress
                  variant="buffer"
                  value={score}
                  valueBuffer={100}
                  style={{ height: 2 }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};
